const componentStyles = (theme) => ({
  cardActionsRoot: {
    paddingBottom: "1.5rem!important",
    paddingTop: "1.5rem!important",
    // borderTop: "0!important",
  },
});

export default componentStyles;